import {useState} from 'react';
import {getPublicCBStandardsByLocation} from 'api/certification-bodies';
import {alertByError} from 'utils/alerts';

function useGetCBStandardsLocation(cbId, abId, cbLocationId) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});

  async function getData(query) {
    setIsLoading(true);
    try {
      const {data, meta} = await getPublicCBStandardsByLocation(cbId, {
        accreditation_bodies_id: abId,
        certification_bodies_location_id: cbLocationId,
        limit: -1,
        ...query,
      });

      setData(data);
      setMeta(meta);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    meta,
    data,
    isLoading,
    reload: getData,
  };
}

export default useGetCBStandardsLocation;
